<div class="container content-box module-content">
    <div class="text-center">
        <h1>Activities</h1>
    </div>
    <hr>
    <h4>Instructions</h4>
    <ol class="numbered-list">
        <li class="number">Download the activity handout by clicking the "Download Handout" button below</li>
        <li class="number">Fill out the handout PDF on your computer, or print it to write your answers on paper</li>
        <li class="number">Download the answer key by clicking the "Download Answer Key" button below and check your answers</li>
    </ol>

    <h4>Activity 1</h4>
    <p>For this activity you will estimate monthly income for Nancy, a single mother.</p>
    <div class="text-center">
        <button type="button" class="btn waves-dark w-25" (click)="downloadHandoutFillablePdf1(); content.downloaded[0] = true" [class.invalid]="content.validate && !content.downloaded[0]">Download Handout</button>
        <button type="button" class="btn waves-dark w-25" (click)="downloadKeyPdf1(); content.downloaded[1] = true" [class.invalid]="content.validate && !content.downloaded[1]">Download Answer Key</button>
    </div>

    <h4>Activity 2</h4>
    <p>Keep track of spending for a month. At the end of the month, total the amount spent for each spending category.</p>
    <div class="text-center">
        <button type="button" class="btn waves-dark w-25" (click)="downloadHandoutFillablePdf2(); content.downloaded[2] = true" [class.invalid]="content.validate && !content.downloaded[2]">Download Handout</button>
        <button type="button" class="btn waves-dark w-25" (click)="downloadKeyPdf2(); content.downloaded[3] = true" [class.invalid]="content.validate && !content.downloaded[3]">Download Answer Key</button>
    </div>

    <h4>Activity 3</h4>
    <p>Go through the checklist and classify items as essential, important, and unecessary. </p>
    <div class="text-center">
        <button type="button" class="btn waves-dark w-25" (click)="downloadHandoutFillablePdf4(); content.downloaded[4] = true" [class.invalid]="content.validate && !content.downloaded[4]">Download Handout</button>
    </div>
</div>

<div class="container navigate-buttons">
    <button type="button" class="btn waves-dark w-25" (click)="goBack($event)"><i class="fas fa-angle-left mr-3"></i>{{backTitle}}</button>
    <div class="invalid-feedback inline-summary text-right" *ngIf="content.validate && !allOf(content.downloaded)">Follow the above instructions to proceed.</div>
    <button type="button" class="btn waves-dark w-25" (click)="previewByAdmin || allOf(content.downloaded) || !delay ? goNext($event) : content.validate = true" [delay-click]="delay ? 60 : 0" delay-tooltip="Finish reading through instructions and completing handouts first.">{{nextTitle}}<i class="fas fa-angle-right ml-3"></i></button>
</div>
